import React from "react";
import { useLang } from "../i18n/LanguageContext";

// Toggle discreto IT ⇄ EN posizionato in alto a destra su ogni schermata.
export default function LanguageToggle() {
  const { lang, toggle, t } = useLang();
  return (
    <button
      onClick={toggle}
      data-testid="language-toggle"
      aria-label={t.toggleAria}
      className="fixed top-3 right-3 z-50 flex items-center gap-1 rounded-full px-3 py-1.5 bg-white/70 backdrop-blur border text-[11px] font-mono uppercase tracking-[0.2em] text-[color:var(--ac-ink-soft)] hover:text-[color:var(--ac-ink)] hover:bg-white transition"
      style={{ borderColor: "var(--ac-border-strong)" }}
    >
      <span className={lang === "it" ? "text-[color:var(--ac-ink)]" : ""}>IT</span>
      <span className="opacity-40">·</span>
      <span className={lang === "en" ? "text-[color:var(--ac-ink)]" : ""}>EN</span>
    </button>
  );
}
